import { Box, Chip } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Marketing_Support_Enum } from '@kheops/graphql';
import { arrayToggle } from '../../common/utils/common.utils';

export interface MarketingSupportsSelectProps {
  values: Marketing_Support_Enum[];
  onChange: (supports: Marketing_Support_Enum[]) => void;
}

export default function MarketingSupportsSelect({ values, onChange }: MarketingSupportsSelectProps): React.JSX.Element {
  const { t } = useTranslation(['settings']);
  const [selected, setSelected] = useState(values);

  const handleChange = (support: Marketing_Support_Enum): void => {
    const newSelected = [...selected];

    arrayToggle(newSelected, support);
    setSelected(newSelected);
    onChange(newSelected);
  };

  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      <Chip
        className={selected.includes(Marketing_Support_Enum.Furniture) ? 'Kheops-selected' : ''}
        variant="filter"
        onClick={() => handleChange(Marketing_Support_Enum.Furniture)}
        label={t('settings:marketing.values.furniture')}
      />
      <Chip
        className={selected.includes(Marketing_Support_Enum.Pos) ? 'Kheops-selected' : ''}
        variant="filter"
        onClick={() => handleChange(Marketing_Support_Enum.Pos)}
        label={t('settings:marketing.values.pos')}
      />
      <Chip
        className={selected.includes(Marketing_Support_Enum.Other) ? 'Kheops-selected' : ''}
        variant="filter"
        onClick={() => handleChange(Marketing_Support_Enum.Other)}
        label={t('settings:marketing.values.other')}
      />
    </Box>
  );
}
